import { createSlice } from '@reduxjs/toolkit';

import { IPatientState } from 'src/features/patient/domain/types';

import { PATIENT_LOADING_KEY, getPatientDetails } from './patientThunks';

const initialState: IPatientState = {
	patientDetails: null,
};

const patientSlice = createSlice({
	name: PATIENT_LOADING_KEY,
	initialState: initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getPatientDetails.fulfilled, (state, action) => {
			state.patientDetails = action.payload;
		});
	},
});

export default patientSlice.reducer;
